var cached_config;

/**
 * Get App Configuration Hash
 * @param  {String} url Url of config file.
 * @return {Promise}
 */
var getConfig = function (url) {
  if (cached_config) {
    return cached_config;
  }

  url = url ? url : window.cfg.cfg_url;

  /**
   * Get configuration file.
   * @param  {Function} resolve Promise Resolution
   * @param  {Function} reject  Promise Rejection
   * @return {undefined}
   */
  var executor = function (resolve, reject) {
    var request = new XMLHttpRequest();

    var handleResponse = function (response) {
      var config = JSON.parse(response).configuration;
      resolve(config);
    };

    var handleStateChange = function () {
      if (request.readyState === XMLHttpRequest.DONE) {
        if (request.status === 200) {
          handleResponse(request.response);
        }
      }
    };

    request.onreadystatechange = handleStateChange;
    request.open("GET", url, true);
    request.send(null);
  };

  cached_config = new Promise (executor);

  return cached_config;
};

module.exports = getConfig;
